import React from 'react'
import LogoutIcon from '../elements/icons/LogoutIcon'
import { authHeader, baseUrl, userDetails } from '../../utils';
import axios from "axios"
import { useNavigate } from "react-router-dom"
// import ErrorMessage from '../elements/ErrorMessage';
import Avatar from '../../assets/images/placeholder-avatar-male.jpg'
import { useDispatch } from 'react-redux';
import { ERROR } from '../../store/types';

const AdminHeader = ({pageTitle, sidebarActive, sidebarToggleFunction}) => {
    let navigate = useNavigate()    
    const dispatch = useDispatch()

    const logOut = async () => {
        try {
            const headers = authHeader()
            
            const response = await axios.delete(`${baseUrl}/auth/sessions`, {}, { headers })            
            if(!response.data.status) {
                dispatch({
                    type: ERROR,
                    error: {response: {data: {
                        message: response.message
                    }}}
                })
            }
        } catch (error) {
            if(error.response.status === 401 || error.response.status === 403) {
                navigate("/")
            } else {
                dispatch({
                    type: ERROR,
                    error: {response: {data: {
                        message: error.response.data.message
                    }}}
                })
            }
        }
    }
    const user = userDetails()
    return (
        <div className="p-3 h-20 z-20 flex bg-white items-center flex-row gap-x-4">
            <button className="text-primary text-opacity-70 hover:text-opacity-90 transition duration-200" onClick={()=>{sidebarToggleFunction()}}>
                <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 6h16M4 12h8m-8 6h16" />
                </svg>
            </button>

            <h1 className="text-lg text-primary font-medium w-1/4">{pageTitle}</h1>

            <div className="w-full flex flex-row-reverse">
                <div onClick={()=>{logOut()}} className="cursor-pointer text-primary rounded-md mx-4 w-10 h-10 flex items-center justify-center bg-gray-100 pl-1">
                    <LogoutIcon classes="h-6 w-6" />
                </div>
                {/* <button className="text-primary relative rounded-md ml-4 w-10 h-10 flex items-center justify-center bg-gray-100">
                    <span className="rounded-full w-2 h-2 absolute top-0 right-0 bg-accent" />
                    <BellIcon />
                </button> */}
                <div className='flex items-center gap-x-1'>
                        <div className='w-[41px]'>
                            <div className='bg-white rounded w-[40px] h-[40px] border border-white shadow-lg shadow-vcm-purple/30'
                                style={{
                                    backgroundImage: `url(${user.avatar || Avatar})`,
                                    backgroundPosition: 'center center',
                                    backgroundSize: 'cover',
                                    backgroundRepeat: 'no-repeat'
                                }}
                            ></div>
                        </div>
                        <p className='font-wix-mf-display text-vcm-purple'>{user.name}</p>
                    </div>
            </div>
        </div>
    )
}

export default AdminHeader
